import * as React from "react";
import { tv, VariantProps } from "tailwind-variants";
import { cn } from "@repo/utils/cn";
import { ComponentProps } from "react";
import { ErrorIcon } from "@repo/ui-parkmobile/icons/ErrorIcon";

const inputContainer = tv({
  base: "uipm:relative uipm:w-full",
});

export const input = tv({
  base: cn(
    "uipm:w-full uipm:rounded-xl",
    "uipm:px-4 uipm:py-4 uipm:min-h-[56px]",
    "uipm:text-[length:var(--typography-sizes-body-medium,16px)] uipm:leading-[var(--typography-line-heights-body-medium,26px)]",
    "uipm:text-[var(--typography-colors-text-faded-dark)] uipm:font-medium",
    "uipm:placeholder:text-[var(--typography-colors-text-faded)] uipm:placeholder:font-medium",
    "uipm:border-2 uipm:border-transparent uipm:transition-colors",
    "uipm:font-['Inter']",
    "uipm:outline-none",
    "uipm:focus:border-[var(--color-color-light)] uipm:focus-visible:border-[var(--color-color-light)]",
    "uipm:focus:placeholder:text-transparent",
    "uipm:active:border-[var(--color-color-light)]",
  ),
  variants: {
    state: {
      default: "",
      error:
        "uipm:border-[var(--color-color-danger)] uipm:pr-12 uipm:text-[var(--color-color-danger)]",
      disabled: "uipm:opacity-50 uipm:cursor-not-allowed",
    },
    background: {
      default: "uipm:form-hover",
      white: "uipm:bg-white",
    },
  },
  defaultVariants: {
    state: "default",
    background: "default",
  },
});

export type InputProps = VariantProps<typeof input> &
  ComponentProps<"input"> & {
    className?: string;
    containerClassName?: string;
  };

export function Input({
  className,
  containerClassName,
  state,
  background,
  disabled,
  ...props
}: InputProps) {
  const inputState = disabled ? "disabled" : state;
  const showErrorIcon = state === "error";

  return (
    <div className={cn(inputContainer(), containerClassName)}>
      <input
        disabled={disabled}
        {...props}
        className={cn(input({ state: inputState, background }), className)}
      />
      {showErrorIcon && (
        <div className="uipm:absolute uipm:right-4 uipm:top-1/2 uipm:-translate-y-1/2 uipm:pointer-events-none">
          <ErrorIcon />
        </div>
      )}
    </div>
  );
}
